import axios from '@axios'

export default {
    namespaced: true,
    actions: {
        fetchDevices(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios.get('maps/get_devices', { params: queryParams })
                    .then(response => resolve(response)).catch(error => reject(error))
            })
        },
    },
}
